import { Grid, Typography } from '@mui/material';
import { useStyles } from './styles';
import FeatureStatistics from '..';
import { type StatisticDataType } from '../types';

export type FeatureStatisticsGroupProps = {
  data: {
    data: StatisticDataType[];
    gradient: string;
    title: string;
  };
};

const FeatureStatisticsGroup = ({ data }: FeatureStatisticsGroupProps) => {
  const { data: singleData, gradient, title } = data;
  const classes = useStyles({ gradient });

  return (
    <Grid item container className={classes.containerStatistics}>
      {title && (
        <Grid item xs={12} className={classes.titleRow}>
          <Typography className={classes.blockTitle} component="h3" variant="overline">
            {title}
          </Typography>
        </Grid>
      )}
      {singleData?.map(({ headline, value, icon, explanation }, index) => (
        <Grid item xs={12} sm={4} key={`${headline}-${index}`} className={classes.itemStatistics}>
          <FeatureStatistics headline={headline} value={value} icon={icon} explanation={explanation} />
        </Grid>
      ))}
    </Grid>
  );
};

export default FeatureStatisticsGroup;
